import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HeartHandshake } from "lucide-react";
import { api } from "../lib/api";
import { HeartRequestCard } from "../pages/HeartRequests";

export function MyHeartRequests() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/me/heart-requests").then((r) => setRows(r.data || [])).catch(() => setRows([])); }, []);
  return (
    <section data-testid="dashboard-heart-requests">
      <div className="flex items-end justify-between mb-4">
        <div><div className="eyebrow mb-1">My Heart Requests</div><h2 className="font-serif text-2xl" style={{ color: "var(--burgundy)" }}>Prayer requests, held privately.</h2></div>
        <Link to="/heart-requests" className="text-xs ink-link" style={{ color: "var(--burgundy)" }} data-testid="my-heart-requests-link">Bring a Heart Request</Link>
      </div>
      {rows === null ? null : rows.length === 0 ? (
        <div className="rounded-xl border p-6 text-sm text-center" style={{ background: "var(--bg-cream-card)", borderColor: "var(--border-cream)", color: "var(--text-muted)" }}>
          <HeartHandshake className="w-5 h-5 mx-auto mb-2" style={{ color: "var(--gold-dark)" }} />What is your heart carrying? <Link to="/heart-requests" className="ink-link font-medium" style={{ color: "var(--burgundy)" }}>Bring a Heart Request</Link>.
        </div>
      ) : <div className="space-y-3">{rows.slice(0, 3).map((r) => <HeartRequestCard key={r.id} r={r} />)}{rows.length > 3 && <Link to="/heart-requests" className="text-xs ink-link" style={{ color: "var(--burgundy)" }}>View all {rows.length} requests →</Link>}</div>}
    </section>
  );
}
